// import { User } from "@/models/user";
import { Pagination } from "@/models/pagination";
import { RootState } from "@/types";
import { DepartmentState } from "@/types/department";
import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";
import { Module } from "vuex";
import { Department } from "@/models/department";

const state: DepartmentState = {
  single: new Department(),
  pagination: new Pagination(),
};

export const department: Module<DepartmentState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
